var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1536 15.0878L24.4637 14.3186V26.03H3.9142V6.47796H16.5375L15.0941 4.88501L14.7418 4.52771L12.7505 2.508H0V30H28.3779V18.3581L25.5059 15.4451L25.1536 15.0878Z",
    fill: "#7A7784"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8557 1.36964L18.9781 2.50802L21.3217 4.88504L19.7512 6.47799L12.9316 13.3947L16.7636 17.2812L24.4638 9.47134L25.1537 8.77163L28.378 12.0419L28.6197 12.287L29.9701 0L17.8557 1.36964Z",
    fill: "#7A7784"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit_icon.999dfbd95a7fbf4527f3f9f5b71be283.svg";